import React, { createContext, useState } from "react";

export const AutoRegistrationContext = createContext();

export const AutoRegistrationProvider = ({ children }) => {
  const [step, setStep] = useState(0);
  const [data, setData] = useState({});
  const [branches, setBranches] = useState([]);


  return (
    <AutoRegistrationContext.Provider value={{ step, setStep, data, setData, branches, setBranches }}>
      {children}
    </AutoRegistrationContext.Provider>
  );
};
